import * as React from "react";
import { Link } from "react-router-dom";

export default class AdventureList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openToursCollection: [
        {
          slug: "ancient-trails",
          name: "Ancient Trails",
          thumbnail: { url: "/img/3.webp" },
          duration: "6 days",
          season: "Summer",
          type: "Hut-to-Hut Hiking Tour",
          text: "Hike away from the crowds",
          price: "$3500/person",
          message: "Top pick"
        },
        {
          slug: "glacier-express",
          name: "Glacier Express",
          thumbnail: { url: "/img/66-min.jpg" },
          duration: "8 hours",
          season: "Winter",
          type: "Jeep & Hiking Tour",
          text: "Hike on a glacier",
          price: "32.900 ISK/person"
        },
        {
          slug: "northern-lights",
          name: "Northern Lights",
          thumbnail: { url: "/img/DSC01360.jpg" },
          duration: "4 hours",
          season: "Winter",
          type: "Evening Jeep Tour",
          text: "Find the aurora with us",
          price: "23.900 ISK/person"
        },
      ],
      privateToursCollection: [
        {
          slug: "golden-circle",
          name: "Golden Circle",
          thumbnail: { url: "/img/NorseAdventures_2024 6-resize-compress.jpg" },
          duration: "8 hours",
          season: "All year",
          type: "Luxury Tour",
          text: "Most famous sights",
          price: "240.000 ISK/person"
        },
        {
          slug: "south-coast",
          name: "South Coast",
          thumbnail: { url: "/img/5W0A0462-Edit.jpg" },
          duration: "10 hours",
          season: "All year",
          type: "Luxury Tour",
          text: "Waterfalls and black beaches",
          price: "280.000 ISK/person"
        },
        {
          slug: "valley-of-thor",
          name: "Valley of Thor",
          thumbnail: { url: "/img/IMG_20211025_133142.jpg" },
          duration: "8 hours",
          season: "All year",
          type: "Jeep Tour",
          text: "River crossing and nature",
          price: "240.000 ISK/person"
        },
        {
          slug: "rainbow-mountains",
          name: "Rainbow Mountains",
          thumbnail: { url: "/img/Brennisteinsalda.jpg" },
          duration: "10 hours",
          season: "All year",
          type: "Jeep Tour",
          text: "Otherworldly landscapes",
          price: "280.000 ISK/person"
        },
      ],
    };
  }

  render() {
    return (
      <div
        id="adventures"
        className="flex flex-col w-full max-w-[1408px] py-16 px-4 laptop:px-16"
      >
      <h1 className="text-3xl text-center mb-12">This is what we <strong><i>specialize</i></strong> in.</h1>
        <div className="flex flex-col gap-8">
          <ul className="grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 gap-8">
            {this.state.openToursCollection.length > 0 ? (
                this.state.openToursCollection.map((e) => (
                    <Link to={"/adventures/" + e.slug}>
                      <li className="flex flex-col w-full aspect-[3/4] group text-white rounded-lg overflow-hidden bg-black">
                        <div className="h-full relative flex flex-col items-center">
                          <div className="relative h-full bg-black">
                            <img
                              src={e.thumbnail.url}
                              className="z-20 w-full h-full object-cover group-hover:brightness-110 bg-black"
                            />
                            <img
                              className="w-full h-full absolute top-0 bg-gradient-to-t from-black/50 via-black/0 to-black/0"
                            />
                          </div>
                          <div className="absolute bottom-0 m-0 p-0 w-full">
                            <div className="relative z-20 p-8 flex flex-col items-center leading-none">
                              <span className="w-full text-center text-xl drop-shadow-[0_0_1px_rgba(0,0,0,1)]">{e.type}</span>
                              <span className="w-full text-center tracking-wide font-['norse'] text-5xl drop-shadow-[0_0_1px_rgba(0,0,0,1)]">{e.name}</span>
                              <span className="w-full text-center text-2xl drop-shadow-[0_0_1px_rgba(0,0,0,1)]">{e.text}</span>
                              <span className="w-full text-center text-2xl mt-1 tracking-wide italic drop-shadow-[0_0_1px_rgba(0,0,0,1)]">{e.duration} / {e.season}</span>
                            </div>
                            <div className="absolute z-10 bottom-0 left-0 right-0 top-0 w-full h-full bg-gradient-to-t from-black to-transparent"></div>
                          </div>
                        </div>
                      </li>
                    </Link>
                  ))
              ) : (
                <span className="text-4xl col-span-full text-center">
                  No Open Tours Found
                </span>
              )}
          </ul>

          <ul className="grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-4 gap-8">
            {this.state.privateToursCollection.length > 0 ? (
                this.state.privateToursCollection.map((e) => (
                    <Link to={"/adventures/" + e.slug}>
                      <li className="flex flex-col w-full aspect-[3/4] group text-white rounded-lg overflow-hidden bg-black">
                        <div className="h-full relative flex flex-col items-center">
                          <div className="relative h-full bg-black">
                            <img
                              src={e.thumbnail.url}
                              className="z-20 w-full h-full object-cover group-hover:brightness-110 bg-black"
                            />
                            <img
                              className="w-full h-full absolute top-0 bg-gradient-to-t from-black/50 via-black/0 to-black/0"
                            />
                          </div>
                          <div className="absolute bottom-0 m-0 p-0 w-full">
                            <div className="relative z-20 p-4 flex flex-col items-center leading-none">
                              <span className="w-full text-center text-xl drop-shadow-[0_0_1px_rgba(0,0,0,1)]">{e.type}</span>
                              <span className="w-full text-center tracking-wide font-['norse'] text-4xl drop-shadow-[0_0_1px_rgba(0,0,0,1)]">{e.name}</span>
                              <span className="w-full text-center text-xl drop-shadow-[0_0_1px_rgba(0,0,0,1)]">{e.text}</span>
                              <span className="w-full text-center text-xl mt-1 tracking-wide italic drop-shadow-[0_0_1px_rgba(0,0,0,1)]">{e.duration} / {e.season}</span>
                            </div>
                            <div className="absolute z-10 bottom-0 left-0 right-0 top-0 w-full h-full bg-gradient-to-t from-black to-transparent"></div>
                          </div>
                        </div>
                      </li>
                    </Link>
                  ))
              ) : (
                <span className="text-4xl col-span-full text-center">
                  No Private Tours Found
                </span>
              )}
          </ul>

          <div className="w-full h-96 relative group bg-black">
            <img
              src="/img/Hornstrandir 152-resize-compress.jpg"
              alt="A man standing on a cliff overlooking Hrafntinnusker"
              className="w-full object-cover h-full group-hover:brightness-110 rounded-lg overflow-hidden"
            />
            <div className="absolute left-0 top-0 bottom-0 right-0 bg-black bg-opacity-20"></div>
            <div className="absolute h-full w-auto items-center justify-center top-0 left-0 flex flex-col">
              <div className="flex flex-col justify-center gap-4 w-full h-full p-4 laptop:p-16">
                <span className="text-3xl tablet:text-4xl laptop:text-5xl desktop:text-6xl text-white font-black drop-shadow-md">
                  Let's plan your own custom tailored itinerary!
                </span>
                <div className="flex flex-row text-xl desktop:text-3xl font-black">
                  <Link
                    to="/tailored"
                    className="bg-neutral-100 hover:bg-neutral-200 p-4 rounded-lg"
                  >
                    Build your dream trip
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}
